module.exports = "/dist/f300da4fb4fe00e23915f62b2c643681.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-600.woff
// module id = 128
// module chunks = 0